var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 0C7.12692 0 7.5 0.3731 7.5 0.833333C7.5 1.26069 7.17831 1.61292 6.76385 1.66106L6.66667 1.66667H2.5C2.07264 1.66667 1.72041 1.98837 1.67227 2.40282L1.66667 2.5V12.5C1.66667 12.9274 1.98837 13.2796 2.40282 13.3277L2.5 13.3333H6.25C6.71025 13.3333 7.08333 13.7064 7.08333 14.1667C7.08333 14.594 6.76164 14.9463 6.34719 14.9944L6.25 15H2.5C1.1686 15 0.0802828 13.9593 0.00424385 12.6469L0 12.5V2.5C0 1.1686 1.04077 0.0802828 2.35311 0.00424385L2.5 0H6.66667ZM11.4225 4.55372L13.7796 6.91075C14.105 7.23617 14.105 7.76383 13.7796 8.08925L11.4225 10.4462C11.0971 10.7717 10.5695 10.7717 10.244 10.4462C9.91858 10.1208 9.91858 9.59317 10.244 9.26775L11.1785 8.33333H6.66667C6.20642 8.33333 5.83333 7.96025 5.83333 7.5C5.83333 7.03975 6.20642 6.66667 6.66667 6.66667H11.1785L10.244 5.73223C9.91858 5.4068 9.91858 4.87916 10.244 4.55372C10.5695 4.22828 11.0971 4.22828 11.4225 4.55372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.08ae378ab027f9a6f3d4e31c39e8712a.svg";
export { ForwardRef as ReactComponent };